import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';

import './MarketPricingChart.scss';

class Chart extends Component {
  static propTypes = {
    container: PropTypes.string,
    modules: PropTypes.array,
    options: PropTypes.object,
    type: PropTypes.string
  };
  componentDidMount() {
    // Extend Highcharts with modules
    if (this.props.modules) {
      this.props.modules.forEach(function(module) {
        module(Highcharts);
      });
    }
    // Set container which the chart should render to.
    this.chart = new Highcharts[this.props.type || 'Chart'](this.props.container, this.props.options);
  }
  //Destroy chart before unmount.
  UNSAFE_componentWillUnmount() {
    this.chart.destroy();
  }
  render() {
    return <div id={this.props.container} />;
  }
}

class MarketPricingChart extends Component {
  static propTypes = {
    pricedJobsCount: PropTypes.number,
    slottedJobsCount: PropTypes.number,
    neitherJobsCount: PropTypes.number,
    chartInteraction: PropTypes.func
  };

  chartClick(event) {
    this.props.chartInteraction(event.point.name);
    return false;
  }
  chartLegendClick(event) {
    this.props.chartInteraction(event.target.name);
    return false;
  }

  render() {
    const config = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        title: {
          text: null,
          enabled: false
        },
        legend: {
          enabled: false
        },
        width: 400,
        height: 225
      }
    };
    const { pricedJobsCount, slottedJobsCount, neitherJobsCount } = this.props;

    config.xAxis = {
      lineColor: '#d3d3d3',
      tickLength: 0,
      categories: ['Priced', 'Slotted', 'Neither'],
      labels: {
        style: {
          color: '#464249',
          fontSize: '14px'
        }
      }
    };

    config.yAxis = {
      tickPixelInterval: 75,
      title: {
        enabled: null
      },
      labels: {
        style: {
          color: '#c3c3ca',
          fontSize: '14px'
        }
      }
    };
    config.yAxis.title.enabled = false;
    config.credits = {
      enabled: false
    };
    config.title = {
      text: null
    };
    config.plotOptions = {
      column: {
        pointWidth: 60,
        pointPadding: 20,
        groupPadding: 0
      }
    };

    config.series = [
      {
        animation: true,
        cursor: 'pointer',
        name: '',
        borderColor: '',
        label: {
          enabled: false
        },
        showInLegend: false,
        point: {
          events: {
            click: this.chartClick.bind(this),
            legendItemClick: this.chartLegendClick.bind(this)
          }
        },
        data: [
          { name: 'Priced', color: '#a7eff1', y: parseInt(pricedJobsCount, 10) },
          { name: 'Slotted', color: '#a7eff1', y: parseInt(slottedJobsCount, 10) },
          { name: 'Neither', color: '#a7eff1', y: parseInt(neitherJobsCount, 10) }
        ]
      }
    ];

    return <Chart container="marketPricingChart" options={config} module={null} />;
  }
}

export default MarketPricingChart;
